import { callGetExternalApi, callPostExternalApi, callPutExternalApi } from '@ctn/axios-util';

import { type IListado, type IPagination } from '@/interfaces/model/generic.interface';
import { type IUser, type IUserListado } from '@/interfaces/model/user.interface';
import { processError } from '@/utils/axiosErrors';
import axiosInstance from '@/utils/axiosInterceptor';

type ISolicitudParams = {
	id?: number;
};

export type IUsuariosListadoPayload = IPagination & {
	nombre?: string;
	email?: string;
	activo?: boolean;
	listaIdRol?: number[];
};

export type IUsuarioPayload = Pick<
IUser,
| 'nombre'
| 'apellido1' 
| 'apellido2' 
| 'email'
| 'telefono'
| 'username'
| 'id'
| 'listaAcciones'
| 'listaTiposNotificacionTramite'
| 'envioNotificacionMail'
> & Partial<Pick<IUser, 'rol'>>;

export type IUsuariosListadoResponse = IListado<IUserListado>;

const getBackendUrl = ({ id }: ISolicitudParams) => ({
	POST_USUARIOS_LISTADO: '/usuarios/listado/',
	POST_USUARIO: '/usuarios',
	GET_USUARIO: `/usuarios/detalle/${id}`,
	PUT_USUARIO_ESTADO_ACTIVO: `/usuarios/estado-activo/${id}`,
});

export const postUsuariosListado = async (data: IUsuariosListadoPayload) =>
	callPostExternalApi<IUsuariosListadoResponse>({
		axiosInstance,
		processError,
		withCredentials: true,
		url: getBackendUrl({}).POST_USUARIOS_LISTADO,
		data,
	});

export const postUsuario = async (data: IUsuarioPayload) =>
	callPostExternalApi<number>({
		axiosInstance,
		processError,
		withCredentials: true,
		url: getBackendUrl({}).POST_USUARIO,
		data,
	});

export const getUsuario = async (id: number) =>
	callGetExternalApi<IUser>({
		axiosInstance,
		processError,
		withCredentials: true,
		url: getBackendUrl({ id }).GET_USUARIO,
	});

export const putUsuarioEstadoActivo = async (id: number) =>
	callPutExternalApi<undefined>({
		axiosInstance,
		processError,
		withCredentials: true,
		url: getBackendUrl({ id }).PUT_USUARIO_ESTADO_ACTIVO,
	});
